import React, { PropTypes } from 'react'
import './style.less'

function TriRoundRow({ headlines, images, captions, links }) {
  const [ headline1, headline2, headline3 ] = headlines
  const [ image1, image2, image3 ] = images
  const [ caption1, caption2, caption3 ] = captions
	const [ link1, link2, link3 ] = links
  const columnClass = 'col-xs-12 col-sm-6 col-md-4'
  return (
    <div className="row center-xs tri-round-row">
      <div className={columnClass}>
				<a href={link1}>
	        <h2>{headline1}</h2>
	        <img src={image1} />
	        <p>{caption1}</p>
				</a>
      </div>
      <div className={columnClass}>
				<a href={link2}>
        	<h2>{headline2}</h2>
        	<img src={image2} />
        	<p>{caption2}</p>
				</a>
      </div>
      <div className={columnClass}>
				<a href={link3}>
        	<h2>{headline3}</h2>
        	<img src={image3} />
        	<p>{caption3}</p>
				</a>
      </div>
    </div>
  )
}

TriRoundRow.propTypes = {
  headlines: PropTypes.array,
  images: PropTypes.array,
  captions: PropTypes.array,
	links: PropTypes.array
}

TriRoundRow.defaultProps = {
  headlines: [],
  images: [],
  children: [],
	links: []
}

export default TriRoundRow



// WEBPACK FOOTER //
// ../components/TriRoundRow/index.js